export const environment = {
    production: false,
}

export const apis = {
    baseUrl: 'https://api.elitemoving.uk/api',
    //baseUrl: 'https://elite-api.codegenio.com/api',
    //googleApiKey: 'AIzaSyCq-_3Fqmw-4Y6tdKFToydCYdVaprzHTjA',old
    //googleApiKey: 'AIzaSyBL1s2dW9MXDsvblZoe_D7r4VihtgZ1x_M',
    googleApiKey: 'AIzaSyDUboXCDL1g5NpYtbuSK8rXH1EqE8mPDxE',
    googleCaptchaSiteKey: ''
}

export const socialLoginUrls = {
    google: `${apis.baseUrl}/public/login/google`,
    facebook: `${apis.baseUrl}/public/login/facebook`
}

export const appURL = 'https://elitemoving.uk'
